import { createFileRoute } from '@tanstack/react-router';
import { ContratoLinkCompartilhamento } from '@/features/contrato/page/link-compartilhamento/ContratoLinkCompartilhamento';

export const Route = createFileRoute('/p/contrato/$id')({
    component: Component,
});

function Component() {
    const { id } = Route.useParams();

    return <ContratoLinkCompartilhamento id={id} />;
}
